import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-cards',
  templateUrl: './ui-cards.component.html',
  styleUrls: ['./ui-cards.component.scss']
})
export class UiCardsComponent implements OnInit {
  viewTab: boolean = true;
  codeTab: boolean;
  codeTab7: boolean;
  viewTab7: boolean = true;
  codeTab6: boolean;
  codeTab5: boolean;
  viewTab6: boolean = true;
  viewTab5: boolean = true;
  codeTab4: boolean;
  viewTab4: boolean = true;
  codeTab3: boolean;
  viewTab3: boolean = true;
  codeTab1: boolean;
  codeTab2: boolean;
  viewTab2: boolean = true;
  viewTab1: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

  onMenuTab(number) {
    this.viewTab = false;
    this.codeTab = false;

    if (number == '1') {
      this.viewTab = true;
    }
    else if (number == '2') {
      this.codeTab = true;
    }
  }

  onMenuTab2(number) {
    this.viewTab1 = false;
    this.codeTab1 = false;

    if (number == '1') {
      this.viewTab1 = true;
    }
    else if (number == '2') {
      this.codeTab1 = true;
    }

  }
  onMenuTab3(number) {
    this.viewTab2 = false;
    this.codeTab2 = false;

    if (number == '1') {
      this.viewTab2 = true;
    }
    else if (number == '2') {
      this.codeTab2 = true;
    }
  }
  onMenuTab4(number) {
    this.viewTab3 = false;
    this.codeTab3 = false;

    if (number == '1') {
      this.viewTab3 = true;
    }
    else if (number == '2') {
      this.codeTab3 = true;
    }
  }
  onMenuTab5(number) {

    this.viewTab4 = false;
    this.codeTab4 = false;

    if (number == '1') {
      this.viewTab4 = true;
    }
    else if (number == '2') {
      this.codeTab4 = true;
    }
  }
  onMenuTab6(number) {

    this.viewTab5 = false;
    this.codeTab5 = false;

    if (number == '1') {
      this.viewTab5 = true;
    }
    else if (number == '2') {
      this.codeTab5 = true;
    }
  }
  onMenuTab7(number) {
    this.viewTab6 = false;
    this.codeTab6 = false;

    if (number == '1') {
      this.viewTab6 = true;
    }
    else if (number == '2') {
      this.codeTab6 = true;
    }
  }

  onMenuTab8(number) {
    this.viewTab7 = false;
    this.codeTab7 = false;

    if (number == '1') {
      this.viewTab7 = true;
    }
    else if (number == '2') {
      this.codeTab7 = true;
    }
  }

}
